export const getLocaleText = (faText: string, enText: string): string => {
  return (localStorage.getItem("lang") || "fa") == "fa" ? faText : enText;
};
